import React from 'react';

function OgRate({ name, value, unit }) {
  return (
    <div className="og-rate">
      <div className="rname">{name}</div>
      <div className="rval">
        <span className="cur">$</span>
        <span className="amt">{value}</span>
      </div>
      <div className="runit">{unit}</div>
    </div>
  );
}

export default OgRate;
